import {
  Provider,
  TypedUseSelector,
  useSelector as _useSelector,
  useStore,
} from '../../primer-sdk-web/src/store/PreactUnistore';
import { ICheckoutState } from '../../primer-sdk-web/src/store/BaseStore';

export const useCheckoutStore = useStore;
export const useSelector: TypedUseSelector<ICheckoutState> = _useSelector;
export { Provider };
